import { Group } from './FunnelStageGroup';
import { StageMatchedBreakdown, StageTotalBreakdown } from './FunnelBreakdown';
import { StageType } from './Funnel';
import { z } from 'zod';

export interface EstimatedFunnelStage extends FunnelStage {
  estName: string;
}

export type StageTarget = z.infer<typeof StageTargetDTO>;
export const StageTargetDTO = z.literal('leads');

export interface FunnelStage {
  id: number;
  name: string;
  desc: string;
  icon: string;
  conversionName: string;
  showTotal: boolean;
  isKPI: boolean;
  metrics: Group[];
  type: StageType;
  total: StageTotalBreakdown;
  matched: StageMatchedBreakdown;
  spend?: number;
  costPer?: number;
  showOverview: boolean;
  costPerMetric: number;
  stageTarget?: StageTarget;
}

export interface FunnelStageWithOfflineEventCount {
  id: number;
  name: string;
  desc: string;
  icon: string;
  offlineEventCount: number;
}

// https://developers.facebook.com/docs/facebook-pixel/reference#standard-events
export const standardPixelEvents = [
  'AddPaymentInfo',
  'AddToCart',
  'AddToWishlist',
  'CompleteRegistration',
  'Contact',
  'CustomizeProduct',
  'Donate',
  'FindLocation',
  'InitiateCheckout',
  'Lead',
  'PageView',
  'Purchase',
  'Schedule',
  'Search',
  'StartTrial',
  'SubmitApplication',
  'Subscribe',
  'ViewContent',
] as const;

export type StandardPixelEvent = typeof standardPixelEvents[number];
